export const designPagePath = '/design/model/:modelSlug';

export const getDesignPageUrl = (modelSlug: string) => {
  return designPagePath.replace(':modelSlug', modelSlug);
};